"use client";

import { FC } from "react";
import LocationInput from "../LocationInput";
import RentalCarDatesRangeInput from "./RentalCarDatesRangeInput";
import RentalCarTimesRangeInput from "./RentalCarTimesRangeInput";
import DropOffLocationInput from "../DropOffLocationInput";
import { useData } from "data/data-provider";

export interface RentalCarSearchFormProps {}

const RentalCarSearchForm: FC<RentalCarSearchFormProps> = () => {
  const {
    dropOffLocation,
    setPickupLocation,
    setDropoffLocation,
    setSearchedPickupLocation,
    setSearchedDropoffLocation,
    pickupLocation,
    setDropoffLocationType,
    setSameDropoffLocation,
    dropoffLocationType,
  } = useData();

  const renderRadioBtn = () => {
    return (
      <div className=" py-5 [ nc-hero-field-padding ] flex items-center flex-wrap flex-row border-b border-neutral-100 dark:border-neutral-700">
        <div
          className={`py-1.5 px-4 flex items-center rounded-md font-medium text-sm cursor-pointer mr-2 my-1 sm:mr-3 ${
            dropoffLocationType === true
              ? "bg-primary-100 text-white shadow-black/10 shadow-lg"
              : "border border-neutral-300 dark:border-neutral-700 text-primary-100 bg-white"
          }`}
          onClick={(e) => {
            setDropoffLocationType(true);
            setDropoffLocation(pickupLocation);
            setSearchedDropoffLocation(pickupLocation?.name ?? "");
            setSameDropoffLocation(true);
            setPickupLocation(null);
            setDropoffLocation(null);
            setSearchedPickupLocation("");
            setSearchedDropoffLocation("");
          }}
        >
          Same drop off
        </div>
        <div
          className={`py-1.5 px-4 flex items-center rounded-md font-medium text-sm cursor-pointer mr-2 my-1 sm:mr-3 ${
            dropoffLocationType === false
              ? "bg-primary-100 text-white shadow-black/10 shadow-lg"
              : "border border-neutral-300 dark:border-neutral-700 text-primary-100 bg-white"
          }`}
          onClick={() => {
            setDropoffLocationType(false);
            setSameDropoffLocation(false);
            // Reset values
            setPickupLocation(null);
            setDropoffLocation(null);
            setSearchedDropoffLocation("");
            setSearchedPickupLocation("");
          }}
        >
          Different drop off
        </div>
      </div>
    );
  };

  const isDdropOffdifferent = dropoffLocationType === false;

  return (
    <form className="w-full relative rounded-3xl shadow-xl dark:shadow-2xl bg-[#FFFFFF40] backdrop-blur-sm box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) dark:bg-neutral-800">
      <div className="flex flex-start ml-12 pt-4">
      </div>
      {renderRadioBtn()}
      <div className={`relative flex flex-row`}>
        <LocationInput
          placeHolder="Pick up Location"
          desc="Where are you going?"
          className="flex-1"
          sameDropOffLocation={dropoffLocationType === false}
        />
        {isDdropOffdifferent && (
          <>
            <div className="self-center border-r border-slate-200 dark:border-slate-700 h-8"></div>
            <DropOffLocationInput
              placeHolder="City or Airport"
              desc="Drop off location"
              className="flex-1"
              divHideVerticalLineClass="-inset-x-0.5"
            />
          </>
        )}
        <div className="self-center border-r border-slate-200 dark:border-slate-700 h-8"></div>
        <RentalCarDatesRangeInput className="flex-1" />
        <div className="self-center border-r border-slate-200 dark:border-slate-700 h-8"></div>
        <RentalCarTimesRangeInput
          dropOffLocationType={dropoffLocationType}
          className="flex-2"
        />
      </div>
    </form>
  );
};

export default RentalCarSearchForm;
